import PageMeta from '../../components/common/PageMeta'
import DefaultTable from '../../components/tables/DefaultTable/DefaultTable'
import Badge from '../../components/ui/badge/Badge'
import { useNavigate } from 'react-router'
import ProfessionalCreate from './Create/ProfessionalCreate'
import Card from '../../components/common/Card'
import { useCreate } from '../../context/CreateRegisterContext'
import { useProfessional } from '../../context/ProfessionalContext'
import { useEffect } from 'react'

export default function ProfessionalPage() {
    const { loadProfessionals, professionals } = useProfessional()
    const navigate = useNavigate()
    const { openContact, setOpenContact } = useCreate()

    const columns = [
        {
            key: 'id',
            label: '#'
        },
        {
            key: 'name',
            label: 'Nome'
        },
        {
            key: 'email',
            label: 'E-mail'
        }
    ]

    const handleClick = (row: any) => {
        navigate(`/profissional/${row.id}`)
    }

    useEffect(() => {
        loadProfessionals()
    }, [])

    return (
        <>
            <PageMeta title='Profissionais | CRM' description='Lista todos os profissionais' />
            <div className='space-y-6'>
                <Card>
                    <DefaultTable
                        columns={columns}
                        rows={professionals}
                        rowsPerPage={20}
                        handleClick={handleClick}
                        handleCreate={() => setOpenContact(true)}
                    />
                </Card>
            </div>
            <ProfessionalCreate open={openContact} handleClose={() => setOpenContact(false)} />
        </>
    )
}
